module.exports = __webpack_public_path__ + "img/ardi_logo_white.d0463800.svg";